module.exports = __webpack_public_path__ + "static/media/scotiabank.5eb34386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pay-methods/scotiabank.png
// module id = 576
// module chunks = 0